import { RadiusTheme } from '@kite-js/theme-types';

const radius: RadiusTheme = {
    NONE: '0',
    XS: '2px',
    S: '4px',
    M: '8px',
    L: '16px',
    MAX: '100%',
    ROUNDED: '100vh',
};

export default radius;
